// extracted by mini-css-extract-plugin
export default {"container":"PdfList_container__jvWAX","list":"PdfList_list__TzoqR","item":"PdfList_item__-ypNK","downloadBtn":"PdfList_downloadBtn__O6qrn"};